import { IRoomRectangle, ToolType } from "../../types/Floorplan.types";

export interface IFloorRects {
    floorplanRectangles?: IRoomRectangle[];
    selectedFloorIdx?: number;
    selectedTool?: ToolType;
}

const FloorRects = (props: IFloorRects) => {
    const { floorplanRectangles, selectedFloorIdx, selectedTool } = props;
    if (floorplanRectangles && floorplanRectangles.length > 0) {
        return (
            <g id="floorplan">
                { floorplanRectangles.map((floor, idx) => {
                    let className = "floor floor-" + idx;
                    if (selectedTool === "Pointer" && selectedFloorIdx === idx) {
                        className = "draggable draggableFloor-" + idx;
                    }
                    // if (!room.bookable) className += " nonAvailableDesk";
                    
                    return (
                        <rect className={className} key={`fp_${idx}`} data-idx={idx} x={floor.x} y={floor.y} width={floor.width} height={floor.height} stroke="none" fill="white" />
                    );
                }) }
            </g>
        );
    }
    return null;
};

export default FloorRects;